module.exports = __webpack_public_path__ + "static/10-f2f43cb8f821f57efbf09a25b38cf635.jpg";